import cn from 'classnames';

import Heading from 'components/common/Heading';
import Subheading from 'components/common/Subheading';
import useQuery from 'hooks/useQuery';
import TempoByKrogerLogo from 'images/logo/tempoByKroger.png';
import TempoLogoWhite from 'images/logo/tempoLogoWhite.svg';

const HeaderLogo = ({ showPartnershipLogo, partnershipLogo, partnershipData }) => {
  const { isQueryParamTrue: hasKrogerParam } = useQuery('kroger', 'true');
  const tempoLogo = hasKrogerParam ? TempoByKrogerLogo : TempoLogoWhite;
  const altText = hasKrogerParam ? 'Tempo by Kroger Logo' : 'Tempo Logo';

  if (showPartnershipLogo) {
    return (
      <div className="mx-auto flex max-h-[120px] items-start justify-center px-16 py-3">
        {showPartnershipLogo && (
          <img
            className="max-h-[120px] w-auto object-contain"
            src={partnershipLogo}
            alt={`${partnershipData?.partnership.name} logo`}
          />
        )}
      </div>
    );
  }

  return <img className="w-28 pb-2 bp2:w-36" src={tempoLogo} alt={altText} />;
};

HeaderLogo.propTypes = {
  showPartnershipLogo: PropTypes.bool,
  partnershipLogo: PropTypes.string,
  partnershipData: PropTypes.object,
};

const AdSourceHeaderContent = ({ showPartnershipLogo, partnershipLogo, partnershipData }) => {
  const isSpecialPartnerVariant = showPartnershipLogo;

  return (
    <div
      className={cn(
        'px-6 py-8 text-center',
        isSpecialPartnerVariant ? 'bg-tempo-navy-100' : 'bg-tempo-blue-120'
      )}
    >
      <div className="mx-auto max-w-xl">
        <HeaderLogo
          showPartnershipLogo={showPartnershipLogo}
          partnershipLogo={partnershipLogo}
          partnershipData={partnershipData}
        />
        <Heading className="h4 bp1:h2 text-white-100">Fresh, never frozen meal delivery</Heading>
        <Subheading className="text-white-100" brandStylesOverrides="text">
          Prepared, protein-packed meals that cook in 2 minutes.
        </Subheading>
      </div>
    </div>
  );
};

AdSourceHeaderContent.propTypes = {
  showPartnershipLogo: PropTypes.bool,
  partnershipLogo: PropTypes.string,
  partnershipData: PropTypes.object,
};

export default AdSourceHeaderContent;
